module.exports = __webpack_public_path__ + "img/5.d6a58f73.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":609,"height":356,"variants":[{"file":"img/5-480w.85e7ecfb771d.webp","width":480},{"file":"img/5-609w.86ccd18a7843.webp","width":609}]};
}